/**
 * Mobil sayfa geçişlerinde beyaz ekran / donmayı önler.
 * Scroll kilidi, sabit body ve açık dialog'ları navigasyon öncesi temizler.
 */
(function () {
  'use strict';

  var MOBILE_MQ = window.matchMedia('(max-width: 749px), (hover: none)');

  function isMobileLike() {
    return MOBILE_MQ.matches || (navigator.maxTouchPoints > 0 && window.innerWidth < 990);
  }

  function releaseNavigationLocks() {
    document.documentElement.removeAttribute('scroll-lock');
    document.documentElement.classList.remove('overflow-hidden');

    var body = document.body;
    if (!body) return;

    body.style.removeProperty('width');
    body.style.removeProperty('position');
    body.style.removeProperty('top');
    body.style.removeProperty('overflow');
  }

  function removeRenderBlocker() {
    var blocker = document.getElementById('view-transition-render-blocker');
    if (blocker) blocker.remove();
  }

  function closeOpenDialogs() {
    document.querySelectorAll('dialog[open]').forEach(function (dialog) {
      try {
        dialog.close();
      } catch (err) {
        /* ignore */
      }
    });
  }

  function prepareForNavigation() {
    releaseNavigationLocks();
    closeOpenDialogs();
    removeRenderBlocker();
  }

  if (isMobileLike()) {
    removeRenderBlocker();
  }

  window.addEventListener('pagehide', prepareForNavigation, { capture: true });
  window.addEventListener('pageswap', prepareForNavigation, { capture: true });

  window.addEventListener('pagereveal', function () {
    prepareForNavigation();
  });

  window.addEventListener('pageshow', function (event) {
    prepareForNavigation();
    if (event.persisted) closeOpenDialogs();
  });

  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') {
      releaseNavigationLocks();
    }
  });
})();
